<template>
  <div class="pa-3 bg-complementary border-radius-bottom">
    <ListModule
      v-if="state == 'list'"
      @newState="setState('new')"
      @editModule="editModule($event)"
    ></ListModule>
    <NewModule
      v-if="state == 'new'"
      @listState="setState('list')"
      :moduleEdit="moduleEdit"
    ></NewModule>
  </div>
</template>
<script>
import ListModule from "@/components/ipcomtact/listModules.vue";
import NewModule from "@/components/ipcomtact/newModule.vue";
export default {
  components: {
    ListModule,
    NewModule,
  },
  data() {
    return {
      state: "list",
      moduleEdit: "",
    };
  },
  methods: {
    editModule(IPComtactModule) {
      this.moduleEdit = IPComtactModule;
      this.state = "new";
    },
    setState(state) {
      this.state = state;
      this.moduleEdit = "";
    },
  },
};
</script>
